import {
  startOfDay,
  endOfDay,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  format,
} from 'date-fns';
import type { HearingDatePreset } from '../constants/courseHearings.constants';

const DATE_KEY = 'yyyy-MM-dd';

// Monday-based week, to match the platform's weekly views.
const WEEK_OPTS = { weekStartsOn: 1 as const };

export interface HearingDateRange {
  dateFrom: string;
  dateTo: string;
}

export const getPresetDateRange = (
  preset: HearingDatePreset,
  now: Date = new Date()
): HearingDateRange => {
  switch (preset) {
    case 'today':
      return {
        dateFrom: format(startOfDay(now), DATE_KEY),
        dateTo: format(endOfDay(now), DATE_KEY),
      };
    case 'month':
      return {
        dateFrom: format(startOfMonth(now), DATE_KEY),
        dateTo: format(endOfMonth(now), DATE_KEY),
      };
    case 'week':
    default:
      return {
        dateFrom: format(startOfWeek(now, WEEK_OPTS), DATE_KEY),
        dateTo: format(endOfWeek(now, WEEK_OPTS), DATE_KEY),
      };
  }
};
